(function() {
    'use strict';

    angular.module('GorillaBoy.directives')
    .directive('subFolderList', [
        '$timeout',
        'moveModalState',
        'MessageProvider',
        'SourceConstant',
        subFolderList
    ]);

    function subFolderList($timeout, moveModalState, MessageProvider, SourceConstant) {
        return {
            scope: {
                folders: '=',
                pushFolder: '=',
                state: '=',
                updateSelectedFolder: '=',
                sourceFolderIdSet: '='
            },
            restrict: 'E',
            link: function(scope, element, attrs) {
                scope.messages = {
                    noFolders: MessageProvider.moveModalNoFolders,
                    error: MessageProvider.moveModalFailLoadingFolder
                };
                scope.selectedFolderId = null;
                scope.icons = {
                    folderIcon: 'images/move_modal_folder_icon.png',
                    disabledFolderIcon: 'images/move_modal_folder_icon_disabled.png'
                };

                scope.selectFolder = function(folder) {
                    if (scope.sourceFolderIdSet[folder.Id]) {
                        return;
                    }

                    scope.selectedFolderId = folder.Id;
                    // Pass the selected folder ID to the outside scope.
                    scope.updateSelectedFolder(folder.Id, folder.Name);
                };

                scope.openFolder = function(folder) {
                    if (scope.sourceFolderIdSet[folder.Id]) {
                        return;
                    }

                    scope.pushFolder(folder.Id, folder.Name);
                    scope.selectedFolderId = null;
                };
            },
            templateUrl: './move-modal/sub_folder_list.html'
        };
    }
}());
